import { useTranslation } from "react-i18next";
import { Hash, FileText, CalendarClock, Building, MapPin } from "lucide-react";
import { Field } from "../../../components/neu/Field";

const FIELDS = [
  ["trn", "branches.trn", "text", "emerald", Hash],
  ["trade_license_no", "branches.licenseNo", "text", "sky", FileText],
  ["license_expiry", "branches.licenseExpiry", "date", "rose", CalendarClock],
  ["license_authority", "branches.licenseAuthority", "text", "amber", Building],
];

export const LegalTab = ({ form, setNested }) => {
  const { t } = useTranslation();

  return (
    <div className="grid gap-5 sm:grid-cols-2">
      {FIELDS.map(([key, label, type, accent, icon]) => (
        <Field
          key={key}
          label={t(label)}
          testId={`branch-${key}`}
          type={type}
          value={form.legal[key] ?? ""}
          onChange={(v) => setNested("legal", key, v)}
          accent={accent}
          icon={icon}
        />
      ))}
      <div className="sm:col-span-2">
        <Field
          label={t("branches.legalAddress")}
          testId="branch-legal_address"
          value={form.legal.legal_address ?? ""}
          onChange={(v) => setNested("legal", "legal_address", v)}
          accent="violet"
          icon={MapPin}
        />
      </div>
    </div>
  );
};
